import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { PPE_BASIC_02_Schema } from './PPE_BASIC_02_Schema';

/**
 * PPE_BASIC_02(보호구 관리대장) 관련 React Query 훅 모음
 */

// 보호구 관리대장 조회
export const useSearch1 = (options = {}) => {
  const { onSuccess, context } = options;

  // queryKey에 context 정보 포함
  const queryKey = [
    'PPEManagement',
    'getPpeBasic02R1',
    context?.search?.custCd || '',
    context?.search?.currentYear || '',
    context?.search?.currentMonth || '',
  ];

  const query = useQuery({
    queryKey,
    queryFn: () => {
      
      // queryFn 내에서 최신 context로 params 생성
      const params = mapParamsBySchema(
        PPE_BASIC_02_Schema.mapper.search1,
        context
      );
      return apiRequest(
        'post',
        Global.urls.PPEManagement.getPpeBasic02R1,
        params
      ).then((response) => {
        return response;
      });
    },
    enabled: false, // 자동 실행 방지
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt, query.data]);

  return query;
};

// 보호구 관리대장 저장
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, PPE_BASIC_02_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.PPEManagement.savePpeBasic02U1,
      payload
    );
  }, options);
};
